import React from 'react';
import PropTypes from 'prop-types';

import { pluralize } from 'helpers';
import ProductName from 'components/productdetail/ProductName';
import Price from 'components/productdetail/Price';
import ReviewSummary from 'components/productdetail/ReviewSummary';
import Tooltip from 'components/common/Tooltip';

import styles from 'styles/components/productdetail/productSummary.scss';

const ProductSummary = ({ product, style, percentOffText, showPercentOffBanner, showReviewSummary, onReviewsClick }, { testId }) => {
  const { productId, productRating, overallRating, reviewCount } = product;

  const content = (
    <ul className={styles.reviewSummaryTooltip}>
      {overallRating.map((rating, index) => {
        const i = 5 - index;
        return (
          <li key={`rating${i}`} className={styles.reviewRating}>
            <span className={styles.percentPrefix}>{i} {pluralize('star', i)}</span>
            <span className={styles.percentBar}><span
              style={{ width: `${rating}%` }}/></span>
            <span className={styles.percentNumber}>{rating}%</span>
          </li>
        );
      })}
    </ul>
  );

  return (
    <div className={styles.productSummary}>
      <span id="overview" className={styles.productName}>
        <ProductName product={product}/>
        {showReviewSummary && (
          <span className={styles.reviewSummaryWrapper}>
            <Tooltip
              tooltipId="reviewSummary"
              content={content}>
              <ReviewSummary
                numReviews={reviewCount}
                rating={productRating}
                productId={productId}
                data-test-id={testId('productReviews')}
                onReviewsClick={onReviewsClick}/>
            </Tooltip>
          </span>
        )}
      </span>
      <span className={styles.price}>
        <Price productStyle={style} percentOffText={percentOffText} showPercentOffBanner={showPercentOffBanner}/>
      </span>
    </div>
  );
};

ProductSummary.propTypes = {
  product: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
  percentOffText: PropTypes.string,
  showPercentOffBanner: PropTypes.bool,
  showReviewSummary: PropTypes.bool
};

ProductSummary.contextTypes = {
  testId: PropTypes.func
};

export default ProductSummary;
